import React from "react";

export const LookupItems = ({
  id,
  searchValue,
  onClickHandler,
  inputFocus,
  data = [],
  items = [], // Për përputhshmëri me prapa (backward compatibility)
  type = "airport",
  loading = false
}) => {
  // Përdor ose 'data' ose 'items' në varësi se cili është i disponueshëm
  const displayData = data.length ? data : items;
  
  // Debug log
  
  // Show loading state
  if (loading) {
    return (
      <ul
        id={id}
        className="list-group"
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          margin: 0,
          padding: "0.75rem 1rem",
          listStyle: "none",
          background: 'white',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          border: '1px solid #ddd',
          zIndex: 1000
        }}
      >
        <li style={{ color: "#666" }}>Searching...</li>
      </ul>
    );
  }

  // nothing to show
  if (!inputFocus || displayData.length === 0) {
    if (inputFocus && searchValue && searchValue.length >= 2) {
      return (
        <ul
          id={id}
          className="list-group"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            margin: 0,
            padding: "0.75rem 1rem",
            listStyle: "none",
            background: 'white',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            border: '1px solid #ddd',
            zIndex: 1000
          }}
        >
          <li style={{ color: "#666" }}>Nuk u gjet asnjë përputhje</li>
        </ul>
      );
    }
    return null;
  }

  return (
    <ul
      id={id}
      className="list-group"
      style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        margin: 0,
        padding: 0,
        listStyle: "none",
        background: 'white',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid #ddd',
        maxHeight: '300px',
        overflowY: 'auto',
        zIndex: 1000
      }}
    >
      {displayData.map((item) => {
        // Përcakto nëse përbën përputhje me emër alternativ
        const isAlternativeMatch = item.alternative_city_name && 
          (Array.isArray(item.alternative_city_name) ? 
            item.alternative_city_name.some(name => 
              searchValue && name.toLowerCase().includes(searchValue.toLowerCase())
            ) : 
            searchValue && item.alternative_city_name.toLowerCase().includes(searchValue.toLowerCase())
          );

        return (
          <li
            key={item.geoname_id || item.id}
            className="list-group-item list-group-item-action"
            style={{
              cursor: "pointer",
              color: "#003663",
              padding: "0.75rem 1rem",
              borderBottom: '1px solid #eee',
              transition: 'background-color 0.2s ease'
            }}
            onMouseDown={() => {
              onClickHandler(item);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f8f9fa';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            {type === "city"
              ? `${item.name} (${item.country_name || item.country_code})`
              : (
                <div>
                  <div style={{ fontWeight: isAlternativeMatch ? 'bold' : 'normal' }}>
                    {`${item.city_name} - ${item.name}`}
                  </div>
                  {isAlternativeMatch && Array.isArray(item.alternative_city_name) && (
                    <div style={{ fontSize: '0.8em', color: '#666' }}>
                      Gjetur si: {item.alternative_city_name.filter(name => 
                        name.toLowerCase().includes(searchValue.toLowerCase())
                      ).join(', ')}
                    </div>
                  )}
                </div>
              )
            }
          </li>
        );
      })}
    </ul>
  );
};
